import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { handleAxiosError } from "./responses/AxiosResponseHandler";

class AddOrSetPhotoAsProfileApi {
    private authClient: AuthClient;
    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public async addImageOrSetPhotoAsProfile(imageCount: number, setAsProfilePicture: boolean) {
        try {

            const authenticationResponse = this.authClient.getAuthenticationResponse();
            const response = await axios.post(
                `${this.authClient.getApiRoot()}/userProfile/addOrSetImgAsProfile/${imageCount}/${setAsProfilePicture}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${authenticationResponse?.token}`,
                    },
                }
            );

            return {
                statusCode: response.status,
                errorMessage: "",
            };

        } catch (error) {
            const errorResponse = handleAxiosError(error as AxiosError);
            return {
                statusCode: errorResponse.statusCode,
                errorMessage: errorResponse.errorMessage
            };
        }
    }
}

export default AddOrSetPhotoAsProfileApi;